export const asm = {
  asm: {
    mainLogoLabel: 'SAP',
    mainTitle: 'Mode de service assisté',
    logout: 'Se déconnecter',
    hideUi: 'Fermer le MSA',
    customers: 'Clients',
    createCustomerSuccessfullyAlert: 'Le compte client a été créé et la session client a démarré.',
    saveInactiveCartAlertInfo: 'Le panier identifié est un panier inactif. Pour effectuer d\'autres actions sur ce panier, sauvegardez-le d\'abord.',
    activeCartAlertInfo: 'Le panier identifié est un panier actif.',
    startCustomerEmulationAlertInfo: 'L\'émulation client a démarré. Toutes vos actions se refléteront sur le compte client.',
    toggleUi: {
      collapse: 'Masquer le MSA',
      expand: 'Afficher le MSA',
    },
    loginForm: {
      submit: 'Se connecter',
      userId: {
        label: 'ID de l\'agent',
        required: 'L\'ID de l\'agent est obligatoire',
      },
      password: {
        label: 'Mot de passe',
        required: 'Le mot de passe est obligatoire',
      },
    },
    customerSearch: {
      searchTerm: {
        label: 'Nom du client / Adresse courriel',
      },
      submit: 'Démarrer la session',
      startEmulation: 'Démarrer l\'émulation',
      noMatch: 'Aucun client trouvé.',
      noMatchResult: 'Ce compte est introuvable.',
      createCustomer: 'Créer un nouveau client',
    },
    createCustomerForm: {
      title: 'Créer un nouveau client',
      createAccount: 'Créer',
      cancel: 'Annuler',
      firstName: {
        label: 'Prénom',
        placeholder: 'Prénom',
      },
      lastName: {
        label: 'Nom de famille',
        placeholder: 'Nom de famille',
      },
      emailAddress: {
        label: 'Adresse courriel',
        placeholder: 'Adresse courriel',
      },
      createAccountAlert: 'La session client démarre dès que vous créez le compte client.',
      validationErrors: {
        firstName: 'Veuillez saisir un prénom valide.',
        lastName: 'Veuillez saisir un nom de famille valide.',
        emailAddress: 'Veuillez saisir une adresse courriel valide.',
      },
      badRequestDuplicatedEmail: 'Veuillez saisir une adresse courriel différente, car {{ emailAddress }} existe déjà.',
    },
    customerList: {
      title: 'Liste des clients',
      description: 'Sélectionnez un client parmi les listes disponibles.',
      createCustomer: 'Créer un nouveau client',
      cancel: 'Annuler',
      tableHeader: {
        customer: 'Client',
        customerName: 'Nom du compte',
        name: 'Nom',
        email: 'Courriel',
        emailId: 'Courriel / ID',
        phone: 'Téléphone',
        account: 'Compte',
        cart: 'Panier',
        order: 'Commande',
        view: 'Vue à 360°',
      },
      tableSort: {
        sortBy: 'Trier par',
        byName: 'Nom (croissant)',
        byNameAsc: 'Nom (croissant)',
        byNameDesc: 'Nom (décroissant)',
        byDateAsc: 'Date (croissant)',
        byDateDesc: 'Date (décroissant)',
        byOrderDateAsc: 'Date de commande (croissant)',
        byOrderDateDesc: 'Date de commande (décroissant)',
        byUnit: 'Compte (croissant)',
        byUnitDesc: 'Compte (décroissant)',
      },
      page: {
        page: 'Page {{count}}',
        previous: 'Précédente',
        next: 'Suivante',
      },
      noOfCustomers: '{{count}} clients',
      oneCustomer: '1 client',
      noCustomers: 'Il n\'y a actuellement aucun client dans cette liste.',
      noLists: 'Il n\'y a actuellement aucune liste de clients disponible. Contactez votre administrateur système.',
      listsError: 'Les listes de clients n\'ont pas pu être récupérées. Veuillez réessayer plus tard.',
      searchBox: 'Rechercher',
      enterSearchBox: 'Saisir le nom ou le courriel du client',
    },
    switchCustomer: {
      dialog: {
        title: 'Avertissement',
        body: 'Cliquer sur « Changer de client » mettra fin à l\'émulation de « {{ customerA }} » et démarrera celle de « {{ customerB }} ». Toute modification non sauvegardée pour « {{ customerA }} » sera perdue.',
        actions: {
          switch: 'Changer de client',
        },
      },
    },
    saveCart: {
      saveCartBtn: 'Sauvegarder pour plus tard',
      dialog: {
        saveInfo: 'Sauvegardez le panier avant de pouvoir effectuer d\'autres actions.',
        disableInfo: 'Impossible de sauvegarder le panier car il est vide.',
        title: 'Sauvegarder le panier',
        row: {
          id: 'ID',
          qty: 'Qté',
          total: 'Total',
        },
        actions: {
          save: 'Sauvegarder pour plus tard',
        },
      },
    },
    bindCart: {
      cartNumber: 'Numéro de panier',
      bindCartToCustomer: 'Assigner le panier au client',
      success: 'Le panier a été assigné avec succès',
      assignCartId: 'Assigner un ID de panier au client',
      enterCartId: 'Saisir l\'ID du panier',
      resetCartId: 'Réinitialiser',
      dialog: {
        title: 'Assigner le panier anonyme',
        body: 'Voulez-vous remplacer le panier actif actuel par le panier anonyme? Si vous remplacez le panier actif actuel, il sera sauvegardé comme panier sauvegardé.',
        actions: {
          replace: 'Remplacer le panier',
        },
      },
    },
    csagentTokenExpired: 'Votre session d\'agent du service client a expiré.',
    endSession: 'Terminer la session',
    endEmulation: 'Terminer l\'émulation',
    agentSessionTimer: {
      label: 'Expiration de la session',
      minutes: 'min',
      reset: 'Réinitialiser',
    },
    auth: {
      agentLoggedInError: 'Impossible de se connecter en tant qu\'utilisateur lorsqu\'une session d\'agent SC est active. Veuillez émuler l\'utilisateur ou déconnecter l\'agent SC.',
    },
    error: {
      noCustomerId: 'Aucun ID client trouvé pour l\'utilisateur sélectionné. Impossible de démarrer la session.',
    },
  },
};
